@if (bulkAction) {
  <div class="bulk-actions-container">
    <h3>Bulk Action #{{bulkAction.bulkActionId}}</h3>
    <div class="bulk-action-detail">
      <div>Name: {{bulkAction.bulkActionName}}</div>
      <div>Type: {{bulkAction.bulkActionType}}</div>
      <div>Status: {{bulkAction.bulkActionStatus}}</div>
      @if (bulkAction.gatewayEnvironmentKey) {
        <div>Gateway Environment: {{bulkAction.gatewayEnvironmentKey}}</div>
      }
      <div>Created: {{bulkAction.createdDateTime}}</div>
      <div>Created By: {{bulkAction.creatorEmail}}</div>
    </div>
    <app-sms-assignment [bulkAction]="bulkAction"></app-sms-assignment>
  </div>
}
